import React from 'react';
import './Footer.css';

function Footer() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section footer-about">
            <div className="footer-logo">
          <img src="/images/logo.png" width="150px" height="120px"></img>

              {/* <span className="logo-cloud">Cloud</span>
              <span className="logo-shift">Shift</span> */}
            </div>
            <p>
              CloudShift Technologies Private Limited - Your trusted partner for 
              IT consultancy, web applications, and mobile app development.
            </p>
          </div>
          
          <div className="footer-section footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>Home</a></li>
              <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About Us</a></li>
              <li><a href="#why-choose-us" onClick={(e) => { e.preventDefault(); scrollToSection('why-choose-us'); }}>Why Choose Us</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Services</a></li>
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact Us</a></li>
            </ul>
          </div>
          
          <div className="footer-section footer-services">
            <h3>Our Services</h3>
            <ul>
              <li>Web Application Development</li>
              <li>Mobile App Development</li>
              <li>IT Consultancy</li>
              <li>Cloud Solutions</li>
            </ul>
          </div>
          
          <div className="footer-section footer-contact">
            <h3>Contact Info</h3>
            <ul>
              {/* <li>📍 Your City, India</li> */}
              <li>📧 info@cloudshiftsystems.com</li>
              {/* <li>📞 +91 9501335987</li> */}
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} CloudShift Technologies Private Limited. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
